import { AppShell, Box } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { PropsWithChildren, ReactNode } from 'react';

import { Header } from './Header/Header';
import styles from './RootLayout.module.css';
import { Sidebar } from './Sidebar/Sidebar';
import { SidebarItem } from './Sidebar/hooks/useSidebar';

export function RootLayout({
  children,
  sidebarItems,
  sidebarHeader,
}: PropsWithChildren<{ sidebarItems: SidebarItem[]; sidebarHeader: ReactNode }>) {
  const [opened, { toggle }] = useDisclosure();

  return (
    <AppShell
      layout="alt"
      header={{ height: 70 }}
      navbar={{ width: 340, breakpoint: 'sm', collapsed: { mobile: !opened } }}
      padding="md"
    >
      <AppShell.Header>
        <Header
          opened={opened}
          toggleMenu={toggle}
        />
        <Box
          id="context-navbar"
          hiddenFrom="sm"
        />
      </AppShell.Header>
      <AppShell.Navbar withBorder={false}>
        <Sidebar
          header={sidebarHeader}
          items={sidebarItems}
          opened={opened}
          toggleMenu={toggle}
        />
      </AppShell.Navbar>
      <AppShell.Main>
        {children}
        <Box
          id="context-footer"
          hiddenFrom="sm"
          className={styles.contextFooter}
        />
      </AppShell.Main>
    </AppShell>
  );
}
